import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { postDefaultProject } from 'api/project.service';

export const DEFAULT_PROJECT_UPDATE_STORE_NAME = 'defaultProjectUpdate';

export const updateDefaultProject = createAsyncThunk(
  `${DEFAULT_PROJECT_UPDATE_STORE_NAME}/update`,
  async (payload: { projectId: string }) => {
    const { projectId } = payload;
    await postDefaultProject(projectId);
  },
);

export interface DefaultProjectUpdateState {
  processing: boolean
  error: any
}

export const initialDefaultProjectUpdateState: DefaultProjectUpdateState = {
  processing: false,
  error: null,
};

export const defaultProjectUpdateSlice = createSlice({
  name: DEFAULT_PROJECT_UPDATE_STORE_NAME,
  initialState: initialDefaultProjectUpdateState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(updateDefaultProject.pending, (state) => {
      state.processing = true;
    });
    builder.addCase(updateDefaultProject.fulfilled, (state) => {
      state.processing = false;
    });
    builder.addCase(updateDefaultProject.rejected, (state, action) => {
      state.error = action.payload;
      state.processing = false;
    });
  },
});

export const defaultProjectUpdateActions = {
  ...defaultProjectUpdateSlice.actions,
  updateDefaultProject,
};

export default defaultProjectUpdateSlice.reducer;
